// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"ce5251b2","408":"348779f7"}[chunkId] + ".chunk.js";
};